import React from 'react';
import { Tabs, Button, Checkbox, notification, Form, type FormProps, Input, Card, Select, DatePicker, InputNumber, Empty } from 'antd';
import { CouponService } from "./../../services/CouponService";
import { DatePickerProps } from 'antd/lib';
import { RangePickerProps } from 'antd/es/date-picker';
import moment from 'moment';
import dayjs from 'dayjs';
import type { TabsProps } from 'antd';
import { MemberService } from '../../services/MemberService';
import MemberPaymentTransaction from './MemberPaymentTransaction';
import MemberReferral from './MemberReferral';


// {
//     id: number
//     unique_id?: string
//     fullname: string
//     full_name? : string
//     email?: string
//     tel?: string
//     customer_level?: string
//     is_social_account?: number
//     my_reference_code?: string
//     reference_code?: string
//     points?:string
//     expired_date?: string
//     created_at?: string
// }
interface Props {
    record: any
    onFinish: () => void
}

export default function Edit(props: Props) {

    const [form] = Form.useForm();
    const [user, setUser] = React.useState(props.record)
    const [noData, setNoData] = React.useState<boolean>(false)

    React.useEffect(() => {
        form.resetFields();
        form.setFieldsValue({
            ...props?.record,
            'expired_date': props?.record?.expired_date && moment(props?.record?.expired_date).isValid() ? dayjs(props?.record?.expired_date) : undefined
        })

        
        if (props?.record?.id) {
            getMember(props?.record?.id)
        }else{
            setNoData(true)
        }
    }, [props?.record?.id])


    const getMember = async (member_id: number) => {
        const res = await MemberService.getMember(member_id)
        if (res?.status == 1) {
            setUser(res.data.user)
            setNoData(false)
        }else{
            setNoData(true)
        }
    }

    // const onFinish: FormProps["onFinish"] = async (values) => {
    //     if (props?.record?.id) {
    //         var res = await CouponService.updateCoupon(values, user.id)
    //     } else {
    //         var res = await CouponService.saveCoupon(values)
    //         form.resetFields();
    //     }

    //     if (res.status == 1) {
    //         notification.open({
    //             type: 'success',
    //             message: res.status_detail,
    //             placement: 'top'
    //         });
    //         if (!props?.record?.id) {
    //             form.resetFields();
    //         }
    //         props.onFinish();
    //     } else {
    //         notification.open({
    //             type: 'error',
    //             message: res.status_detail,
    //             placement: 'top'
    //         });
    //     }
    // };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const onOk = (value: DatePickerProps['value'] | RangePickerProps['value']) => {
        console.log('onOk: ', value);
        form.setFieldValue('expired_date', value)
    };

    const onChange = (key: string) => {
        console.log(key);
    };



    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'User Infomation',
            children: (<>
                <Form
                    name="basic"
                    form={form}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    style={{ maxWidth: 600 }}
                    initialValues={{
                        name: '',
                        limit: 0,
                        expired_date: null
                    }}
                    // onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >





                    <Form.Item
                        label="ID"
                        name="id"
                    >
                        {user.id}
                    </Form.Item>

                    <Form.Item
                        label="Unique ID"
                        name="unique_id"
                    >
                        {user.unique_id}
                    </Form.Item>

                    <Form.Item
                        label="Fullname"
                        name="fullname"
                    >
                        {user.fullname}
                    </Form.Item>

                    <Form.Item
                        label="Email"
                        name="email"
                    >
                        {user.email}
                    </Form.Item>

                    <Form.Item
                        label="Mobile"
                        name="mobile"
                    >
                        {user.tel}
                    </Form.Item>

                    <Form.Item
                        label="Customer Level"
                        name="customer_level"
                    >
                        {user.customer_level}
                    </Form.Item>

                    <Form.Item
                        label="Is Social Account"
                        name="is_social_account"
                    >
                        {user.is_social_account}
                    </Form.Item>

                    <Form.Item
                        label="My Ref. Code"
                        name="my_reference_code"
                    >
                        {user.my_reference_code}
                    </Form.Item>

                    <Form.Item
                        label="Agent Code"
                        name="reference_code"
                    >
                        {user.reference_code}
                    </Form.Item>

                    <Form.Item
                        label="Points"
                        name="points"
                    >
                        {user.points}
                    </Form.Item>






                    <Form.Item
                        label="Registered Date"
                        name="created_at"
                    >
                        {moment(user.created_at).format('DD MMM YYYY HH:mm')}
                    </Form.Item>




                </Form>
            </>),
        },
        {
            key: '2',
            label: 'Transaction history',
            children: <MemberPaymentTransaction user={user}></MemberPaymentTransaction>,
        },
        {
            key: '3',
            label: 'Referral history',
            children:  <MemberReferral user={user}></MemberReferral>,
        },

    ];

    return (
        <Card
            bordered={false}>

            {
                noData ?
                    <Empty></Empty>
                    :

                    <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
            }





        </Card>
    )
}
